<template>
  <div class="ow-terms-and-conditions">
    <div class="ow-terms-and-conditions-header">
      <img src="/images/OxiaLogoAllWhite.png" alt="Icon" class="ow-terms-and-conditions-header-logo" />
      <h1 class="ow-terms-and-conditions-header-title">OXIA PRIVACY POLICY</h1>
    </div>
    <div class="ow-terms-and-conditions-body" ref="privacyPolicyBody">
          <p style="margin-bottom: 0in; text-align: center;">
        <font size="2" style="font-size: 9pt"><b>PRIVACY POLICY</b></font>
      </p>

      <p style="text-align: justify; margin-bottom: 0in"> 
        <font size="2" style="font-size: 9pt"><u><b>1. INTRODUCTION</b></u></font>
      </p>
      <ul>
      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">1.1. This
          is OxIA’s main privacy policy and applies to your use of our
          Platforms, including </font>
        <font size="2" style="font-size: 9pt"><i>inter alia</i></font>
        <font size="2" style="font-size: 9pt">, our
          websites, emails or any other technology or service you use to
          access our Platforms. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">1.2. It
          is important to read this privacy policy together with other terms
          and conditions, privacy notices or policies we may provide. This
          privacy policy supplements the foregoing notices and policies and
          is not intended to override them. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">1.3. We
          respect your privacy and regard the protection of personal
          information as paramount. This privacy policy describes how we
          handle the personal information we collect and/or receive from you.
          By using any of our Platforms, you agree to our collection and use
          of your personal information as set out in this privacy policy. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">1.4. If
          you are below the age of 18 years, you must always obtain
          permission from your parent or legal guardian before providing us
          with your information. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in"><font size="2" style="font-size: 9pt">1.5. “<b>OxIA
            DM Platform</b></font>
        <font size="2" style="font-size: 9pt">” in
          this privacy policy</font>
        <font size="2" style="font-size: 9pt">
          means cloud-based software owned by OxIA, encompassing a wide range
          of features that facilitates the provision of various services in
          the field of healthcare, including without limitation the
          facilitation of screening, reporting and referrals.</font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in"><font size="2" style="font-size: 9pt">1.6. “<b>Platforms</b></font>
        <font size="2" style="font-size: 9pt">”
          in this privacy policy means the various online and digital
          services and/or products operated by OxIA, including but not
          limited to, the OxIA DM Platform, our website, social media
          channels, mobile applications, and any other digital interfaces
          through which we provide our products, services, or content. These
          Platforms may collect, process, and store personal information in
          accordance with this privacy policy. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in"><font size="2" style="font-size: 9pt">1.7. “<b>We</b></font>
        <font size="2" style="font-size: 9pt">”,
          “</font>
        <font size="2" style="font-size: 9pt"><b>us</b></font>
        <font size="2" style="font-size: 9pt">”
          or “</font>
        <font size="2" style="font-size: 9pt"><b>our</b></font>
        <font size="2" style="font-size: 9pt">”
          in this privacy policy refers to OxIA DM (Pty) Ltd and its
          affiliates. </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in"><font size="2" style="font-size: 9pt">1.8. “<b>you</b></font>
        <font size="2" style="font-size: 9pt">”,
          or “</font>
        <font size="2" style="font-size: 9pt"><b>your</b></font>
        <font size="2" style="font-size: 9pt">”
          refers to an individual or legal entity accessing our Platforms,
          including without limitation, healthcare practitioners,
          organizations and their representatives, patients, and the public
          (where applicable). </font>
      </p>



      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">1.9. The
          terms “</font>
        <font size="2" style="font-size: 9pt"><b>personal
            information</b></font>
        <font size="2" style="font-size: 9pt">” and
          “</font>
        <font size="2" style="font-size: 9pt"><b>processing</b></font>
        <font size="2" style="font-size: 9pt">”
          when used in this document shall bear the meanings as set out in
          the Protection of Personal Information Act 4 of 2013, alternatively
          shall bear the meanings assigned to them in applicable local laws
          governing personal information.</font>
      </p>

        
    </ul> 

      <p style="text-align: justify; margin-bottom: 0in">
        <font color="#000000">
          <font size="2" style="font-size: 9pt"><u><b>2. INFORMATION WE COLLECT AND RECEIVE</b></u></font>
        </font>
      </p>


      <ul>
        <p style="text-align: justify; margin-bottom: 0in">
          <font color="#000000">
            <font size="2" style="font-size: 9pt">2.1. We
              collect personal information that is necessary for us to provide
              you with access to our Platforms. We only collect and use the
              minimum personal information we need to provide and improve our
              Platforms. </font>
          </font>
        </p>



        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">2.2. Examples
            of information we may collect, and process include your name, email
            and/or physical address, mobile phone number, location information,
            medical information, payment information, race or ethnic origin,
            age, biometric information, and language.</font>
        </p>



        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">2.3. We
            collect information through interactions with you and when you:</font>
        </p>



        <ul>
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">2.3.1. Complete
              forms, sign up for an account, or subscribe or register to access
              or use our Platforms;</font>
          </p>

          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">2.3.2. Complete
              surveys;</font>
          </p>

          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">2.3.3. Post
              comments or content on our Platforms; and/or</font>
          </p>

          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">2.3.4. Contact
              us.</font>
          </p>
        </ul>
      </ul>


      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>3. INFORMATION WE AUTOMATICALLY COLLECT OR RECEIVE WHEN YOU USE THE PLATFORMS </b></u></font>
      </p>


      <ul>
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">3.1. We
            may automatically collect information about the equipment you use
            to access or use our Platforms, your browsing actions and patterns.
            We do this using cookies, web beacons or other technologies. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">3.2. A
            cookie is a small text file that our server sends to your hard
            drive when you use our Platforms. These cookies hold small amounts
            of data specific to you and our Platforms. They allow our system to
            recognize you when you use our Platforms. Should you so elect, you
            can change your browser settings to disable the use of cookies.
            Please note that if you disable the use of cookies, you may not be
            able to enjoy all the features and functionalities of our
            Platforms. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">3.3. A
            web beacon is a small image file that we place on our Platforms or
            in an email. We use it to track how many times a web page is
            accessed, the time it was accessed and the location of users who
            have accessed it. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">3.4. Depending
            on how you access and use our Platforms, we may receive: </font>
        </p>
      
        <ul>
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">3.4.1. Log
              information, including information on how, when and for how long
              you use our Platforms and other services, the content you view,
              and the search queries you submit.</font>
          </p>
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">3.4.2. Information
              about the equipment you use to access or use our Platforms,
              including the type of device you are using, how you access our
              Platforms, your browser or operating system and your Internet
              Protocol (IP) address; and/or</font>
          </p>
      
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">3.4.3. The
              geographic location from which you access or use our Platforms,
              including your device’s GPS signal and information about nearby
              Wi-Fi networks and cellular towers. We obtain this information
              when you use location-enabled services. </font>
          </p>
        </ul>
      </ul>



      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>4. INFORMATION
              FROM THIRD-PARTY RESOURCES</b></u></font>
      </p>


      <ul>
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">4.1. We
            may receive other information about you from third parties (where
            you have consented to such third parties sharing your information
            with us, or where sharing your personal information with us is for
            our or your legitimate interest or necessary for the use of our
            Platforms). </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">4.2. The
            information which we may collect from third party sources may
            include your location information. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">4.3. We
            may also receive information about you when you log into our
            Platforms using your log-in details. All processing of your
            personal information, including processing using automated means,
            will be done in accordance with applicable privacy laws and the
            provisions of this privacy policy. </font>
        </p>
      </ul>


      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>5. WHAT
              WE DO WITH YOUR PERSONAL INFORMATION</b></u></font>
      </p>


      <ul>
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">5.1. We
            use the personal information we collect and receive to:</font>
        </p>
      
      
      
        <ul>
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.1. Identify
              you, verify your identity, create a user account for you and enter
              into a contract with you;</font>
          </p>
        
        
        
          <p style="text-align: justify; margin-left: 1.48in; margin-bottom: 0in"><br />
        
          </p>
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.2. Provide
              you with information, products, or services you request from us;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.3. Comply
              with any contractual obligations we may have in respect of the
              provision of information, products, or services to you;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.4. Communicate
              with you regarding our Platforms and provide you with, </font>
            <font size="2" style="font-size: 9pt"><i>inter
                alia</i></font>
            <font size="2" style="font-size: 9pt">,
              information, access to the OxIA DM Platform, screening, screening
              reports, billing, customer support, contracts, policies, resolving
              complaints and quality control;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.5. Notify
              you about changes to our Platforms, services and products, terms
              and conditions, pricing policies, or any other changes that impact
              our Platforms and your use thereof;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.6. Make
              our Platforms more user friendly;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.7. Obtain
              feedback from you which we need to develop and improve our
              Platforms;</font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.8. Protect
              our legitimate business interests such as debt recovery and
              keeping our records up to date; and/or </font>
          </p>
        
        
        
        
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">5.1.9. Comply
              with any legal or regulatory obligations. </font>
          </p>
        </ul>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">5.2. We
            may also use your information for research and statistical
            purposes. The research and statistics we acquire from this process
            do not include your personal information and cannot be linked to
            you, nor can you be identified from these statistics. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">5.3. We
            will not use your personal information for any other purpose
            without your permission. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">5.4. We
            retain information for as long as we need it to make our Platforms
            available to you and for as long as required or allowed by law or
            the contract between you and us. </font>
        </p>
      </ul>


      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>6. DISCLOSING
              YOUR PERSONAL INFORMATION</b></u></font>
      </p>


      <ul>
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">6.1. We
            do not sell your personal information to third parties for their
            marketing or any other purposes. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">6.2. We
            may disclose your personal information as follows:</font>
        </p>
      
      
      
        <ul>
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">6.2.1. If
              you are accessing our Platforms as a patient, we may provide your
              personal information to healthcare practitioners, screening
              centers or other third-party service providers, who provide
              services to us or on our behalf, or enable us to provide services
              to you. </font>
          </p>
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">6.2.2. To
              other third parties to whom we are required to provide your
              personal information to comply with applicable law or to protect
              our Platforms.</font>
          </p>
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">6.2.3. To
              prospective and actual purchasers, if we sell, transfer, or merge
              any part of our business or assets.</font>
          </p>
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">6.2.4. To
              other parties that provide content, advertising services or
              functionality on our Platforms. These third parties include,
              without limitation, advertising service providers, audience
              measurements companies, and social networking services. We do not
              control the privacy practices of these or any other third-party
              service providers and recommend you read the privacy policy of
              these service providers. </font>
          </p>
        
          <p style="text-align: justify; margin-bottom: 0in">
            <font size="2" style="font-size: 9pt">6.2.5. We
              may also share your personal information with third parties who
              use artificial intelligence tools.</font>
          </p>
        </ul>
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">6.3. We
            also share our research and statistical information with various
            third parties. However, this information cannot be linked to you,
            and you cannot be identified from these statistics. </font>
        </p>
      
      
      
        <p style="text-align: justify; margin-bottom: 0in">
          <font size="2" style="font-size: 9pt">6.4. We
            will not share your personal information with parties unless they
            are bound by privacy laws and corporate rules or agreements with us
            that protect the privacy of your personal information and limit
            their ability to share your personal information with other
            parties. </font>
        </p>
      </ul>


      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>7. YOUR
              RIGHTS</b></u></font>
      </p>

      <p style="text-align: justify; margin-left: 0.25in; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">You
          have the right to ask us not to contact you for marketing purposes,
          and you can do this at any time by using any of the “opt out”
          options (where / if available), alternatively by emailing us at
        </font>
        <font color="#0000ff"><u><a href="mailto:info@oxia.org">
              <font size="2" style="font-size: 9pt">info@oxia.org</font>
            </a></u></font>
        <font size="2" style="font-size: 9pt">.
          You also have the right to request access to the information we have
          collected about you, request that we correct or update any incorrect
          or incomplete information or request deletion of your personal
          information. Such requests can be submitted by emailing the above
          email address. </font>
      </p>

      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>8. OUR
              COMMITMENT TO SECURITY </b></u></font>
      </p>

      <p style="text-align: justify; margin-left: 0.25in; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">We
          have put in place administrative, technical, and physical safeguards
          to protect your personal information and prevent loss, damage, or
          unauthorised access to your information. These security safeguards
          are based on generally accepted information security practices and
          procedures which apply to our Platforms. Any information you submit
          or use </font>
        <font size="2" style="font-size: 9pt"><i>via</i></font>
        <font size="2" style="font-size: 9pt">
          the internet is at your own risk. Once we receive your personal
          information, our security safeguards shall apply. </font>
      </p>

      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>9. LINKS
              TO OTHER SITES</b></u></font>
      </p>

      <p style="text-align: justify; margin-left: 0.25in; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">Our
          Platforms may contain links to and from other websites, mobile
          applications and/or services of third parties. Clicking on these
          links or enabling these connections may allow third parties to
          collect or share information about you. Please note, we have not
          evaluated nor control these third parties and are not responsible for
          the privacy practices of such other parties when you leave our
          Platforms. We recommend you read the privacy statements of each
          website you visit. </font>
      </p>

      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>10. INTERNATIONAL
              USERS</b></u></font>
      </p>

      <p style="text-align: justify; margin-left: 0.25in; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">OxIA
          is based in South Africa, and irrespective of where you access our
          Platforms, your information may be transferred to and maintained on
          servers located anywhere in the world. Any information that we
          collect about you or receive from you is stored in line with local
          privacy laws applicable in your country. </font>
      </p>

      <p style="text-align: justify; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt"><u><b>11. CHANGES
              TO THIS PRIVACY POLICY</b></u></font>
      </p>

      <p style="text-align: justify; margin-left: 0.25in; margin-bottom: 0in">
        <font size="2" style="font-size: 9pt">This
          version of the privacy policy was last updated on 1 November 2024 and
          replaces any preceding privacy policy. We may occasionally update
          this privacy policy. Any changes we make will be posted on this page
          and we will notify you of the update in the appropriate manner. When
          you use our Platforms the version of the privacy policy posted on
          this page applies to you. We encourage you to review this privacy
          policy whenever you access our Platforms. </font>
      </p>
    </div>
    <BackToTopButton isAbsolute :scrollContainer="privacyPolicyBody"/>
  </div>
</template>

<script setup>
import BackToTopButton from './BackToTopButton.vue';

const privacyPolicyBody = ref(null);
</script>